import $ from 'jquery';
import {Cookie} from 'js/helper/cookie';
import {reachGoal} from "js/utils/analytics";

export default class Search {
    constructor(isMobile = false) {
        this.isMobile = isMobile
        this.cookie = new Cookie();
    }

    event() {
        $('body')
            .on('input', '.search-block-with-type #request', this.handleInputRequestInput.bind(this))
            .on('click', '.search-block-with-type .type-search', this.handlerChangeTypeSearch.bind(this))
            .on('submit', '.search-block-with-type form', this.handlerSubmitValidateSearch.bind(this))
        ;
    }

    handleInputRequestInput(e) {
        let $elem = $(e.currentTarget)
        $elem.closest('.search-block-with-type').find('button[type="submit"]').prop('disabled', $elem.val().length === 0)
    }

    handlerChangeTypeSearch(event) {
        // event.preventDefault();
        let $self = $(event.currentTarget);
        let data = $self.data();
        let $searchBlockWithType = $self.closest('.search-block-with-type');
        let $form = $searchBlockWithType.find('form');
        $form.attr('action', data.action);
        let $request = $form.find('#request');
        $request.attr({
            name: data.name,
            placeholder: data.placeholder
        });
        // $searchBlockWithType.find('.btn-type-search .title').text($self.text());
        // let $typeSearchDropdown = $searchBlockWithType.find('#type-search-dropdown');
        // $typeSearchDropdown.foundation('close');
        // $typeSearchDropdown.find('.block-type-search.active').removeClass('active');
        // $self.closest('.block-type-search').addClass('active');
        $request.removeClass('is-invalid-input');
        $form.closest('label').removeClass('is-invalid-label');
        $form.find('.form-error').removeClass('is-visible');

        $searchBlockWithType.find('.block-type-search').removeClass('active')
        $self.closest('.block-type-search').toggleClass('active')
    }

    handlerSubmitValidateSearch(event) {
        if (location.href.includes('autopart')) {
            try {
                if (window.country_code === 'ru') {
                    ym(49316365, 'reachGoal', 'search-block-button')
                } else if (window.country_code === 'kz') {
                    ym(70024498, 'reachGoal', 'search-block-button-kz')
                }
            } catch (ex) {
            }
        }

        let $self = $(event.currentTarget);
        let $request = $self.find('#request');
        let $label = $self.find('label');
        let $formError = $self.find('.form-error');
        let value = $request.val();
        $request.removeClass('is-invalid-input');
        $label.removeClass('is-invalid-label');
        $formError.removeClass('is-visible');
        let message = '';
        switch ($request.attr('name')) {
            case 'vin':
                if (!/^([a-z0-9]{17}|[a-z0-9-]{7,17})$/i.test(value)) {
                    message = 'Введите правильный VIN-код/FRAME-код (например, XW8AN2NE3JH035743 или KZN185-9023353).';
                }
                break;
            case 'article':
                value = value.replace(/^\s+|\s+$/gm, '');
                if (!value.length) {
                    message = 'Поле должно быть заполнено.';
                } else if (4 > value.length) {
                    message = 'Введите не менее 4 символов.';
                } else if (!/^[a-z0-9.\s/\-]*$/i.test(value)) {
                    message = 'Присутствуют недопустимые символы.';
                } else if (40 < value.length) {
                    message = 'Превышена максимальная длина артиккула (40 символов).';
                }
                break;
        }
        if (message.length) {
            switch ($request.attr('name')) {
                case 'vin':
                    reachGoal('ru_text_vin_frame')
                    break;
                case 'article':
                    reachGoal('ru_text_part_number')
                    break;
            }
            $request.addClass('is-invalid-input');
            $label.addClass('is-invalid-label');
            // $formError.addClass('is-visible').text(message)
            return false;
        }

        this.cookie.setCookie('search_request_name', $request.attr('name'), {'max-age': 2592000});
    }
}
